module.exports = __webpack_public_path__ + "img/120.d83b8336.jpg";